import './bootstrap.js';
import store from './store.js';
import bootstrap from 'bootstrap';

const mapState = Vuex.mapState;

const v = new Vue({
    el : '#app',
    store,
    data : {
        menuVisible : false
    },
    computed: {
        profileLongName() {
            return this.profile ? this.profile.name + ' (' + this.profile.region + ')' : '';
        },
        shouldSeeSaveToHomeBanner() {
            return this.isAppleMobileDevice() && ! this.standAloneMode();
        },
        ...mapState(['profile', 'favorites_list', 'friends_list', 'theme'])
    },
    created() {
        if(token) this.$store.dispatch('initStore');
    },
    methods: {
        trackOutboundLink(category, name) {
            if(window.isProduction)
            {
                gtag('event', 'click', {
                    event_category: category,
                    event_label: name,
                    transport: 'beacon'
                });
            }
        },
        isSafari() {
            return /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
        },
        hasCookie(identifier) {
            let cookie = Cookies.get(identifier);
            return typeof cookie === "undefined" ? false : cookie;
        },
        goToUrl(url) {
            window.location.href = url;
        },
        showMenu() {
            this.menuVisible = true;
            document.body.className = 'noscroll';
        },
        hideMenu() {
            this.menuVisible = false;
            document.body.className = '';
        },
        toggleMenu() {
            if(this.menuVisible) {
               this.hideMenu();
           }else{
                this.showMenu();

           }
        },
        toggleTheme() {
            let theme = this.theme == 'dark' ? 'light' : 'dark';
            this.$store.commit('updateTheme', theme);
        },
        standAloneMode() {
            return ('standalone' in window.navigator) && (window.navigator.standalone);
        },
        isAppleMobileDevice() {
              let userAgent = window.navigator.userAgent.toLowerCase();
              return /iphone|ipad|ipod/.test( userAgent );
        }
    }
});


// Stripe donations
const stripeForm = document.getElementById('donate-form');

if(stripeForm) {
    const stripe = Stripe(window.stripePublicKey);
    const elements = stripe.elements();
    const card = elements.create('card', {
            style: {
                base: {
                    color: '#171920',
                    lineHeight: '18px',
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '14px',
                    backgroundColor: '#ffffff',
                    '::placeholder': {
                        color: '#5A5A5A'
                    }
                },
                invalid: {
                    color: '#CE2938',
                    iconColor: '#CE2938'
                    }
                }
            }
        );

    // Add an instance of the card Element into the `card-element` <div>.
    card.mount('#card-element');
    card.addEventListener('change', function(event) {
      var displayError = document.getElementById('card-errors');
      if (event.error) {
            displayError.textContent = event.error.message;
      } else {
            displayError.textContent = '';
      }
    });

    // Create a token or display an error when the form is submitted.
    stripeForm.addEventListener('submit', function(event) {
        event.preventDefault();

        var button = document.getElementById('donate-submit-button');

        button.setAttribute('disabled', 'disabled');
        stripe.createToken(card).then(function(result) {
            if (result.error) {
                var errorElement = document.getElementById('card-errors');
                errorElement.textContent = result.error.message;
                button.removeAttribute('disabled');
            } else {
                // Send the token to your server.
                donationStripeTokenHandler(result.token);
            }
        });
    });
}

function donationStripeTokenHandler(token) {
    let hiddenInput = document.getElementById('stripe-token-input');
    hiddenInput.setAttribute('value', token.id);

    // Submit the form
    document.getElementById('donate-form').submit();
}

// Stripe disable ads
var disableAdsForm = document.getElementById('disable-ads-form');
if(disableAdsForm)
{
    var stripe = Stripe(window.stripePublicKey);
    var elements = stripe.elements();

    var card = elements.create('card', {
        style: {
            base: {
                color: '#171920',
                lineHeight: '18px',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '14px',
                backgroundColor: '#ffffff',
                '::placeholder': {
                    color: '#5A5A5A'
                }
            },
            invalid: {
                color: '#CE2938',
                iconColor: '#CE2938'
                }
            }
        }
    );

    // Remove ads payment request
    const paymentRequest = stripe.paymentRequest({
        country: 'US',
        currency: 'usd',
        total: {
            label: 'Remove ads on PUBG Lookup',
            amount: 400,
        },
        requestPayerName: true,
        requestPayerEmail: false,
    });

    // Payment request button
    const prButton = elements.create('paymentRequestButton', {
        paymentRequest: paymentRequest,
    });
 
    // Check the availability of the Payment Request API first.
    paymentRequest.canMakePayment().then(function(result) {
        if (result) {
            prButton.mount('#payment-request-button');
        } else {
            document.getElementById('apple-pay-wrapper').style.display = 'none';
        }
    });
    paymentRequest.on('token', function(ev) {
        // Send the token to your server to charge it!
        fetch('/disable-ads', {
            method: 'POST',
            body: JSON.stringify({stripe_token: ev.token.id}),
            headers: {'content-type': 'application/json'},
        }).then(function(response) {
            if (response.ok) {
                ev.complete('success');
                window.location.href = '/disable-ads/thank-you';
            } else {
                ev.complete('fail');
                alert('There was an error accepting payment.');
            }
        });
    });

    // Add an instance of the card Element into the `card-element` <div>.
    card.mount('#card-element');
    card.addEventListener('change', function(event) {
        let displayError = document.getElementById('card-errors');
        if (event.error) {
            displayError.textContent = event.error.message;
        } else {
            displayError.textContent = '';
        }
    });

    disableAdsForm.addEventListener('submit', function(event) {
        event.preventDefault();

        var button = document.getElementById('disable-ads-submit-button');

        button.setAttribute('disabled', 'disabled');
        stripe.createToken(card).then(function(result) {
            if (result.error) {
                var errorElement = document.getElementById('card-errors');
                errorElement.textContent = result.error.message;
                button.removeAttribute('disabled');
            } else {
                // Send the token to your server.
                disableAdsStripeTokenHandler(result.token);
            }
        });
    });
}
function disableAdsStripeTokenHandler(token) {
    let hiddenInput = document.getElementById('stripe-token-input');
    hiddenInput.setAttribute('value', token.id);

    // Submit the form
    document.getElementById('disable-ads-form').submit();
}

